import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./arrow-menu.module.css";

interface ArrowMenuProps {
    items: CallbackAction[];
}

interface CallbackAction {
    id?: string;
    content?: string;
    onAction(): void;
}

export function ArrowMenu({ items }: ArrowMenuProps): JSX.Element {
    return (
        <div>
            {items.map((item) => (
                <ArrowMenuItem key={item.id} onClick={item.onAction}>
                    {item.content}
                </ArrowMenuItem>
            ))}
        </div>
    );
}

interface ArrowMenuItemProps {
    children?: React.ReactChild;
    onClick?();
}

function ArrowMenuItem({ children, onClick }: ArrowMenuItemProps): JSX.Element {
    return (
        <a
            tabIndex={0}
            className={styles.item}
            onClick={(e) => {
                e.preventDefault();
                onClick?.();
            }}
        >
            {children}
            <SVGIcon name={"arrow-right"} className={styles.svgIcon} />
        </a>
    );
}
